import { WebSidebarMenu } from "../WebSidebarMenu";

export const TemplateWebPages = ({ children, navigation}: any) => {
  return (
      <WebSidebarMenu navigation={navigation}>{children}</WebSidebarMenu>
  );
};
